import type { AdapterStatus } from "../../types";

export function getDefaultAdapters(): AdapterStatus[] {
  return [
    {
      id: "local-engine",
      name: "Deterministic Local Engine",
      enabled: true,
      available: true,
      mode: "local-deterministic",
      description: "Core BOB logic — repo grading, planning, exports. No network.",
    },
    {
      id: "openrouter",
      name: "OpenRouterAdapter",
      enabled: false,
      available: false,
      mode: "optional-adapter",
      description: "Optional cloud routing. Disabled by default. Never required.",
    },
    {
      id: "claude-handoff",
      name: "ClaudeCodeHandoffAdapter",
      enabled: true,
      available: true,
      mode: "optional-adapter",
      description: "Generates handoff prompts only — no API account required.",
    },
    {
      id: "local-model",
      name: "LocalModelAdapter",
      enabled: false,
      available: false,
      mode: "optional-adapter",
      description: "Ollama / LM Studio placeholder. Enabled only when endpoint detected.",
    },
    {
      id: "gemini-video",
      name: "GeminiVideoAdapter",
      enabled: false,
      available: false,
      mode: "optional-adapter",
      description: "Library-only video hook. Disabled and non-blocking for BOB.",
    },
  ];
}

export function probeLocalModelEndpoint(): boolean {
  return false;
}

export function refreshAdapterAvailability(adapters: AdapterStatus[]): AdapterStatus[] {
  const localAvailable = probeLocalModelEndpoint();
  return adapters.map((adapter) => {
    if (adapter.id === "local-model") {
      return { ...adapter, available: localAvailable };
    }
    return adapter;
  });
}
